import { render, staticRenderFns } from "./DoubleConfirmDangerDialog.vue?vue&type=template&id=2c06a254"
import script from "./DoubleConfirmDangerDialog.vue?vue&type=script&lang=ts"
export * from "./DoubleConfirmDangerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports